const printSizes = {
  '4x6': [4, 6], '5x7': [5, 7], '6x8': [6, 8],
  '8x10': [8, 10], '8x12': [8, 12], 'A4': [210 / 25.4, 297 / 25.4]
};

export function assessImage(width, height, size) {
  const inches = printSizes[size];
  if (!inches || !width || !height) return null;
  const pixels = [width, height].sort((a, b) => a - b);
  const target = inches.map(value => Math.round(value * 300));
  const ppi = Math.round(Math.min(pixels[0] / inches[0], pixels[1] / inches[1]));
  return { ppi, low: pixels[0] < target[0] || pixels[1] < target[1], target };
}

if (typeof document !== 'undefined') {
  const configNode = document.getElementById('kwik-artwork-quality-config');
  const config = configNode ? JSON.parse(configNode.textContent) : null;
  if (config) {
    const files = new Map();
    const interpolate = (text, values) => text.replace(/__([a-z]+)__/g, (match, key) => values[key] ?? match);
    const selector = 'select[name="options[Print size]"]';
    const selectedSize = () => document.querySelector(selector)?.value;
    const render = () => {
      const select = document.querySelector(selector);
      const size = selectedSize();
      const inches = printSizes[size];
      if (!select || !inches) return;
      let box = document.getElementById('kwik-artwork-quality');
      if (!box) {
        box = document.createElement('div');
        box.id = 'kwik-artwork-quality';
        box.setAttribute('role', 'status');
        box.setAttribute('aria-live', 'polite');
        box.style.cssText = 'margin:12px 0;padding:14px;border:1px solid #d8d8d8;border-radius:8px;background:#f7f7f5;color:#222;font-size:14px;line-height:1.5;white-space:pre-line;overflow-wrap:anywhere';
        select.closest('variant-picker')?.after(box);
        if (!box.isConnected) select.parentElement.after(box);
      }
      const target = inches.map(value => Math.round(value * 300));
      const lines = [interpolate(config.recommended, { size, width: target[0], height: target[1] }), config.orientation, config.review];
      for (const file of files.values()) {
        const result = assessImage(file.width, file.height, size);
        const message = result ? interpolate(result.low ? config.low : config.meets, { ppi: result.ppi, size }) : config.manual;
        lines.push(file.name + ': ' + message);
      }
      const text = lines.join('\n');
      if (box.textContent !== text) box.textContent = text;
    };
    window.addEventListener('upload:added', event => {
      const file = event.detail;
      if (!file?.url || file.meta?.variant === 'thumbnail') return;
      const key = file.url;
      if (files.has(key)) return;
      const entry = { name: file.name || file.filename || new URL(file.url, location.href).pathname.split('/').pop() || config.file };
      files.set(key, entry);
      render();
      const image = new Image();
      image.onload = () => {
        if (files.get(key) !== entry) return;
        entry.width = image.naturalWidth;
        entry.height = image.naturalHeight;
        render();
      };
      image.onerror = render;
      image.src = file.url;
    });
    window.addEventListener('upload:removed', event => {
      files.delete(event.detail?.url);
      render();
    });
    document.addEventListener('change', event => {
      if (event.target.matches(selector)) requestAnimationFrame(render);
    });
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(render).observe(main, { childList: true, subtree: true });
    render();
  }
}
